document.addEventListener('turbolinks:load', function () {
  $('.site_insert_slideup_btn').on('click', function () {
    $.when($(this).parent().parent().children('.site_insert_slide_flag').slideUp()).done($(this).fadeOut(0), $(this).parent().children('.site_insert_slidedown_btn').fadeIn(0));
  });

  $('.site_insert_slidedown_btn').on('click', function () {
    $.when($(this).parent().parent().children('.site_insert_slide_flag').slideDown()).done($(this).fadeOut(0), $(this).parent().children('.site_insert_slideup_btn').fadeIn(0));
  });
  // ------------------------------------------------------------------------------------------------
  // 差し込み配信分析
  // ------------------------------------------------------------------------------------------------
  function site_insert_update_url() {
    const site_insert_id = $('#site_insert_select_box option:selected').val();
    const gf = $('#site_insert_graph_pattern_select_input').val();
    const ab = $('#site_insert_ab_test_select_box option:selected').val();
    const device = $('.site_insert_device_select').data("device");
    const start_day = $('#site_insert_report_start_day').val();
    const end_day = $('#site_insert_report_end_day').val();

    let url = new URL(window.location.href);
    let params = url.searchParams;

    if (site_insert_id !== 'none' && site_insert_id !== null && site_insert_id !== undefined) {
      params.set('site_insert_id', site_insert_id);
    } else {
      params.delete('site_insert_id');
    }

    if (ab !== 'none' && ab !== null && ab !== undefined) {
      params.set('ab', ab);
    } else {
      params.delete('ab');
    }

    if (gf) {
      params.set('gf', gf);
    } else {
      params.delete('gf');
    }

    if (device == "0" || device == "1") {
      params.set('device', device);
    } else {
      params.delete('device');
    }

    if (gf === '12') {
      params.delete('start_day');
      params.delete('end_day');
    } else {  // このelseブロックを追加
      if (start_day) {
        params.set('start_day', start_day);
      } else {
        params.delete('start_day');
        params.delete('end_day');
      }

      if (end_day) {
        params.set('end_day', end_day);
      } else {
        params.delete('start_day');
        params.delete('end_day');
      }
    }

    url.search = params.toString();
    location.href = url.toString();
  }

  // #################################################################
  // 差し込み配信の選択
  // #################################################################
  $('#site_insert_select_box').on('change', function () {
    site_insert_update_url();
  });

  // #################################################################
  // ABテストの選択
  // #################################################################
  $('#site_insert_ab_test_select_box').on('change', function () {
    site_insert_update_url();
  });

  // #################################################################
  // 日毎、月毎のグラフ切り替え
  // #################################################################
  $('.site_insert_graph_pattern_select_day, .site_insert_graph_pattern_select_month').on('click', function () {
    const gf_value = $(this).data('gf');
    $('#site_insert_graph_pattern_select_input').val(gf_value);
    site_insert_update_url();
  });

  // #################################################################
  // デバイスごとのグラフ切り替え
  // #################################################################
  $('.site_insert_device_select_all, .site_insert_device_select_pc, .site_insert_device_select_phone').on('click', function () {
    const device = $(this).data('device');
    $('.site_insert_device_select').data("device", device);
    site_insert_update_url();
  });

  // #################################################################
  // 範囲選択によるグラフ切り替え
  // #################################################################
  $('#site_insert_report_start_day, #site_insert_report_end_day').on('change', function () {
    site_insert_update_url();
  });

  // #################################################################
  // 表の年月切り替え
  // #################################################################
  $('#ua_site_insert_month_selects').on('change', function () {
    let site_insert_id = $('#site_insert_select_box option:selected').val();
    let month = $('#ua_site_insert_month_selects option:selected').val();
    let url = new URL(window.location.href);

    if (month != '') {
      if (url.searchParams.has('m')) {
        // 値が "0"か"1" なら "2" に更新する
        let new_value = month;
        // パラメーターの値を更新する
        url.searchParams.set('m', new_value);
      } else {
        // パラメーターにdeviceがない場合
        // 新しいパラメーターを追加する
        url.searchParams.append('m', month);
      }

      // 更新されたURLにリダイレクトする
      location.href = url.toString();
    } else {
      // monthが空文字の時は指定したURLにリダイレクトする
      // location.href = 'ugc_analysis';
    }
  });

  // #################################################################
  // 差し込み表示のログデータのみの削除
  // #################################################################
  $('.delete_site_insert_log_data').on('click', function () {
    if (!confirm('本当に削除を実行しますか？')) {
      return;
    }
    const site_insert_id = $('#site_insert_select_box option:selected').val();

    $.ajax({
      url: '/site_insert_report/delete_site_insert_log',
      type: 'POST',
      data: {
        site_insert_id: site_insert_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // 差し込み表示のログデータと関連するデータ全ての削除
  // #################################################################
  $('.delete_site_insert_log_data_and_related_data').on('click', function () {
    if (!confirm('本当に完全削除を実行しますか？')) {
      return;
    }
    const site_insert_id = $('#site_insert_select_box option:selected').val();

    $.ajax({
      url: '/site_insert_report/delete_site_insert_log_and_related_data',
      type: 'POST',
      data: {
        site_insert_id: site_insert_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.href = '/site_insert_report/index';
      }
    });
  });

  // #################################################################
  // 差し込み表示のレポートのcsv出力
  // #################################################################
  $('#download_site_insert_csv').on('click', function () {
    const site_insert_id = $('#site_insert_select_box option:selected').val();
    const month = $('#ua_site_insert_month_selects option:selected').val();
    const device = $('.site_insert_device_select').data('device');

    let href = '/download_site_insert_csv';

    href += `?site_insert_id=${site_insert_id}`;
    href += `&m=${month}`;
    href += `&device=${device}`;
    location.href = href;
  });

  // ------------------------------------------------------------------------------------------------
  // 差し込み配信管理
  // ------------------------------------------------------------------------------------------------
  // #################################################################
  // 差し込み配信管理の新規作成
  // #################################################################
  $('#site_insert_create').on('click', function () {
    const name = $('.site_insert_input').val();

    if (!name) {
      alert('差し込み配信名を入力して下さい。');
      return;
    }

    $.ajax({
      url: '/create_site_insert',
      type: 'POST',
      data: {
        name: name,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('新規登録されました。');
        location.href = `/site_insert/index?site_insert_id=${data.site_insert_id}&site_insert_setting_id=${data.site_insert_setting_id}&site_insert_ab_test_id=${data.site_insert_ab_test_id}&device=${data.is_device}`;
      }
    });
  });

  // #################################################################
  // 差し込み配信名の編集
  // #################################################################
  $('#site_insert_name_edit_btn').on('click', function () {
    let site_insert_id = $('.site_insert_selects option:selected').val();
    let name = $('.site_insert_name_val').val();

    if (!name) {
      alert('名称を記入して下さい。');
      return;
    }

    $.ajax({
      url: '/save_site_insert_name',
      type: 'POST',
      data: {
        site_insert_id: site_insert_id,
        name: name
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // 差し込み配信管理の切り替え
  // #################################################################
  $('.site_insert_selects').on('change', function () {
    let site_insert_id = $('.site_insert_selects option:selected').val();
    if (site_insert_id == 'new') {
      $('.site_insert_set_wrapper_display').css('display', 'block');
      $('.site_insert_device_setting_wrapper').css('display', 'none');
      $('.site_insert_ab_test_setting_wrapper').css('display', 'none');
      $('.site_insert_show_valid_setting_wrapper').css('display', 'none');
      $('.site_insert_url_setting_wrapper').css('display', 'none');
      $('.site_insert_excluded_url_setting_wrapper').css('display', 'none');
      $('.site_insert_preview_setting_wrapper').css('display', 'none');
      $('.site_insert_preview_url_list_wrapper').css('display', 'none');
      $('.site_insert_preview_position_setting_wrapper').css('display', 'none');
      $('.site_insert_contents_setting_wrapper').css('display', 'none');
      $('.site_insert_element_setting_wrapper').css('display', 'none');
      $('.site_insert_name_setting_wrapper').css('display', 'none');
      $('.site_insert_report_jump_btn').css('display', 'none');
      $('.site_insert_personalize_setting_wrapper').css('display', 'none');
      $('.site_insert_delete_setting_wrapper').css('display', 'none');
    } else {
      location.href = `/site_insert/index?site_insert_id=${site_insert_id}`;
    }
  });

  // #################################################################
  // 差し込み配信のデバイスの切り替え
  // #################################################################
  $('.site_insert_device_selects').on('change', function () {
    let site_insert_id = $('.site_insert_selects option:selected').val();
    let site_insert_setting_id = $('.site_insert_device_selects:checked').data("site_insert_setting_id");

    location.href = `/site_insert/index?site_insert_id=${site_insert_id}&site_insert_setting_id=${site_insert_setting_id}`;
  });

  // #################################################################
  // 差し込み配信の表示URL設定
  // #################################################################
  $('#site_insert_url_add_input').on('click', function () {
    $(this)
      .parents('table')
      .append(
        `<tr>
            <th></th>
            <td class="h-50px py-0 text-left ">
              <input class="site_insert_url_input w-390px h-30px py-0 px-3 border-b dark:border-none" type="text">
            </td>
            <td class="h-50px py-0 px-6 text-left ">
              <div class="site_insert_url_del text-2xl cursor-pointer text-gray-400 dark:text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                </svg>
              </div>
            </td>
          </tr>`
      );
    $('.site_insert_url_del').on('click', function () {
      $(this).parent().parent('tr').remove();
    });
  });
  $('.site_insert_url_del').on('click', function () {
    $(this).parent().parent('tr').remove();
  });

  $('#site_insert_url_set').on('click', function () {
    let site_insert_id = $('.site_insert_selects option:selected').val();
    let urls = [];
    $('.site_insert_url_input').each(function () {
      urls.push($(this).val().trim());
    });

    $.ajax({
      url: '/set_site_insert_url',
      type: 'POST',
      data: {
        site_insert_id: site_insert_id,
        urls: urls,
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // #################################################################
  // 差し込み配信の除外URL設定
  // #################################################################
  $('#site_insert_excluded_url_add_input').on('click', function () {
    $(this)
      .parents('table')
      .append(
        `<tr>
            <th></th>
            <td class="h-50px py-0 text-left ">
              <input class="site_insert_excluded_url_input w-390px h-30px py-0 px-3 border-b dark:border-none" type="text">
            </td>
            <td class="h-50px py-0 px-6 text-left ">
              <div class="site_insert_excluded_url_del text-2xl cursor-pointer text-gray-400 dark:text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                </svg>
              </div>
            </td>
          </tr>`
      );
    $('.site_insert_excluded_url_del').on('click', function () {
      $(this).parent().parent('tr').remove();
    });
  });
  $('.site_insert_excluded_url_del').on('click', function () {
    $(this).parent().parent('tr').remove();
  });

  $('#site_insert_excluded_url_set').on('click', function () {
    let site_insert_id = $('.site_insert_selects option:selected').val();
    let urls = [];
    $('.site_insert_excluded_url_input').each(function () {
      urls.push($(this).val().trim());
    });

    $.ajax({
      url: '/set_site_insert_excluded_url',
      type: 'POST',
      data: {
        site_insert_id: site_insert_id,
        urls: urls,
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // #################################################################
  // 差し込み配信とコンテンツの連携
  // #################################################################
  $('.site_insert_contents_select_box').on('change', function () {
    let site_insert_id = $('.site_insert_selects option:selected').val();
    let site_insert_ab_test_id = $('.site_insert_ab_test_selects option:selected').val();
    let content_id = $(this).val();
    $.ajax({
      url: '/save_site_insert_content_id',
      type: 'POST',
      data: {
        site_insert_id: site_insert_id,
        site_insert_ab_test_id: site_insert_ab_test_id,
        content_id: content_id
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // #################################################################
  // 差し込み配信とパーソナライズの連携
  // #################################################################
  $('.site_insert_personalize_select_box').on('change', function () {
    let site_insert_id = $('.site_insert_selects option:selected').val();
    let site_insert_ab_test_id = $('.site_insert_ab_test_selects option:selected').val();
    let personalize_id = $(this).val();
    $.ajax({
      url: '/save_site_insert_personalize_id',
      type: 'POST',
      data: {
        site_insert_id: site_insert_id,
        site_insert_ab_test_id: site_insert_ab_test_id,
        personalize_id: personalize_id
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // #################################################################
  // 差し込み配信のプレビュー作成
  // #################################################################
  $('#site_insert_create_preview_btn')
    .off()
    .on('click', function () {
      $('.loadding').css('display', 'block');
      let site_insert_id = $('.site_insert_selects option:selected').val();
      let is_device = $('.site_insert_device_selects:checked').val();
      let site_insert_setting_id = $('.site_insert_device_selects:checked').data("site_insert_setting_id");
      let site_insert_ab_test_id = $('.site_insert_ab_test_selects option:selected').val();
      let preview_url = $('#site_insert_create_preview_url').val();
      if (site_insert_id == '' || site_insert_id == null || preview_url == '') {
        $('.loadding').css('display', 'none');
        alert('必須項目を入力してください。');
        return;
      }

      $.ajax({
        url: '/site_insert/save_site_insert_preview',
        type: 'POST',
        data: {
          site_insert_id: site_insert_id,
          is_device: is_device,
          site_insert_setting_id: site_insert_setting_id,
          site_insert_ab_test_id: site_insert_ab_test_id,
          url: preview_url
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == '0') {
          location.reload();
        }
      });
    });

  // #################################################################
  // 差し込み配信のプレビュー編集
  // #################################################################
  $('.create_site_insert_preview_html_edit').on('click', function () {
    let preview_id = $(this).data('id');
    let preview_url = $(this).data('url');
    $.ajax({
      url: '/edit_site_insert_preview_html',
      type: 'POST',
      data: {
        id: preview_id,
        url: preview_url,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        // モーダルを作成し、HTMLコンテンツとボタンを表示
        let modalHtml = `<div id="html_modal_wrapper"></div>
                        <div id="html_modal_container" class="fixed p-5 top-[2.5%] left-1/2 transform -translate-x-1/2 w-90per h-90per overflow-auto text-center bg-white dark:text-gray-500 dark:bg-gray-900 dark:border-b dark:border-black">
                          <div class="border border-gray-200 h-90per mb-4">
                            <textarea id="html_modal_text_area" class="p-2 h-full w-full"></textarea>
                          </div>
                          <div class="flex justify-center">
                            <div id="html_remove_btn" class="btn text-14px w-250px p-3 cursor-pointer text-center text-white rounded-md bg-gray-500 hover:bg-gray-700 dark:hover:bg-gray-600 dark:bg-gray-800 dark:text-gray-500">閉じる</div>
                            <div id="html_save_btn" class="btn text-14px w-250px p-3 cursor-pointer text-center text-white rounded-md bg-base-800 hover:bg-base-800 ml-2 dark:bg-dark_base dark:hover:bg-dark_base-hover dark:text-gray-500">保存</div>
                          </div>
                        </div>`;

        // モーダルをbody要素に追加
        $('body').append(modalHtml);
        $('#html_modal_text_area').text(data.html_content);

        $('#html_save_btn').on('click', function () {
          let html = $('#html_modal_text_area').val();
          $.ajax({
            url: '/update_site_insert_preview_html',
            type: 'POST',
            data: {
              id: preview_id,
              url: preview_url,
              html: html,
            },
            dataType: 'json',
          }).done(function (data) {
            if (data.ret == '0') {
              location.reload();
            }
          });
        });

        $('#html_modal_wrapper, #html_remove_btn').on('click', function (e) {
          $('#html_modal_wrapper, #html_modal_container, #html_modal_text_area, #html_save_btn').remove();
        });
      }
    });
  });

  // #################################################################
  // 差し込み配信のプレビュー削除
  // #################################################################
  $('.create_site_insert_preview_url_delete').on('click', function () {
    let preview_id = $(this).data('id');
    let preview_url = $(this).data('url');
    $.ajax({
      url: '/delete_site_insert_preview',
      type: 'POST',
      data: {
        id: preview_id,
        url: preview_url,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // 差し込み配信の公開設定
  // #################################################################
  $('.site_insert_show_valid_select_box').on('change', function (event) {
    let site_insert_id = $('.site_insert_selects option:selected').val();
    let site_insert_ab_test_id = $('.site_insert_ab_test_selects option:selected').val();
    let show_valid = $('.site_insert_show_valid_select_box:checked').val();

    $.ajax({
      url: '/save_site_insert_show_valid',
      type: 'POST',
      data: {
        site_insert_id: site_insert_id,
        site_insert_ab_test_id: site_insert_ab_test_id,
        show_valid: show_valid
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // ポップアップの公開期間設定
  // #################################################################
  $('.site_insert_start_datetime, .site_insert_end_datetime').on('change', function (event) {
    let site_insert_id = $('.site_insert_selects option:selected').val();
    let site_insert_ab_test_id = $('.site_insert_ab_test_selects option:selected').val();
    let publication_start = $('.site_insert_start_datetime').val();
    let publication_end = $('.site_insert_end_datetime').val();

    // 開始日時があり、終了日時がない場合
    if (publication_start && !publication_end) {
      let startDate = new Date(publication_start);
      startDate.setMonth(startDate.getMonth() + 1); // 1ヶ月後に設定

      let year = startDate.getFullYear();
      let month = ('0' + (startDate.getMonth() + 1)).slice(-2); // 月は0始まりなので1を加える
      let day = ('0' + startDate.getDate()).slice(-2);
      let hours = ('0' + startDate.getHours()).slice(-2);
      let minutes = ('0' + startDate.getMinutes()).slice(-2);

      publication_end = year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;

      $('.site_insert_end_datetime').val(publication_end);
    }

    // 終了日時があり、開始日時がない場合
    if (!publication_start && publication_end) {
      alert('開始日から入力して下さい。');
      $('.site_insert_end_datetime').val("");
    }

    $.ajax({
      url: '/save_site_insert_publication_date',
      type: 'POST',
      data: {
        site_insert_id: site_insert_id,
        site_insert_ab_test_id: site_insert_ab_test_id,
        publication_start: publication_start,
        publication_end: publication_end
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // 差し込み配信のABテストの新規作成
  // #################################################################
  $('#create_site_insert_ab_test_btn').on('click', function () {
    $('.loadding').css('display', 'block');
    let site_insert_id = $('.site_insert_selects option:selected').val();
    let site_insert_setting_id = $('.site_insert_device_selects:checked').data("site_insert_setting_id");
    let site_insert_ab_test_id = $('.site_insert_ab_test_selects option:selected').val();

    $.ajax({
      url: '/create_site_insert_ab_test',
      type: 'POST',
      data: {
        site_insert_id: site_insert_id,
        site_insert_setting_id: site_insert_setting_id,
        site_insert_ab_test_id: site_insert_ab_test_id
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      } else {
        $('.loadding').css('display', 'none');
        return;
      }
    });
  });

  // #################################################################
  // デフォルトのABテストの設定
  // #################################################################
  $('#update_site_insert_default_ab_test_btn').on('click', function () {
    let site_insert_setting_id = $('.site_insert_device_selects:checked').data("site_insert_setting_id");
    let site_insert_ab_test_id = $("input[name='site_insert_ab_test_radio']:checked").val();

    $.ajax({
      url: '/update_site_insert_default_ab_test',
      type: 'POST',
      data: {
        site_insert_setting_id: site_insert_setting_id,
        site_insert_ab_test_id: site_insert_ab_test_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });
  
  // #################################################################
  // 差し込み配信のABテスト選択
  // #################################################################
  $('.site_insert_ab_test_selects').on('change', function () {
    let site_insert_id = $('.site_insert_selects option:selected').val();
    let site_insert_setting_id = $('.site_insert_device_selects:checked').data("site_insert_setting_id");
    let site_insert_ab_test_id = $('.site_insert_ab_test_selects option:selected').val();

    location.href = `/site_insert/index?site_insert_id=${site_insert_id}&site_insert_setting_id=${site_insert_setting_id}&site_insert_ab_test_id=${site_insert_ab_test_id}`;
  });

  // #################################################################
  // ABテストの選択切り替え
  // #################################################################
  $('#start_site_insert_ab_test_btn, #stop_site_insert_ab_test_btn').on('click', function () {
    let site_insert_id = $('.site_insert_selects option:selected').val();
    let site_insert_setting_id = $('.site_insert_device_selects:checked').data("site_insert_setting_id");

    $.ajax({
      url: '/update_site_insert_ab_test_mode',
      type: 'POST',
      data: {
        site_insert_id: site_insert_id,
        site_insert_setting_id: site_insert_setting_id
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // 要素の挿入先の設定
  // #################################################################
  $('#site_insert_element_set').on('click', function () {
    let site_insert_id = $('.site_insert_selects option:selected').val();
    let site_insert_setting_id = $('.site_insert_device_selects:checked').data("site_insert_setting_id");
    let site_insert_ab_test_id = $('.site_insert_ab_test_selects option:selected').val();

    let element_id_val = $('#element_id_input').val();
    let element_class_val = $('#element_class_input').val();
    let element_index_val = $('#element_index_input').val();
    let parent_id_val = $('#parent_id_input').val();
    let parent_class_val = $('#parent_class_input').val();
    let parent_index_val = $('#parent_index_input').val();
    let grand_id_val = $('#grand_id_input').val();
    let grand_class_val = $('#grand_class_input').val();
    let grand_index_val = $('#grand_index_input').val();
    let great_grand_id_val = $('#great_grand_id_input').val();
    let great_grand_class_val = $('#great_grand_class_input').val();
    let site_insert_element_placement = $('.site_insert_list .site_insert_placement option:selected').val();

    $.ajax({
      url: '/create_site_insert_element',
      type: 'POST',
      data: {
        site_insert_id: site_insert_id,
        site_insert_setting_id: site_insert_setting_id,
        site_insert_ab_test_id: site_insert_ab_test_id,
        element_id: element_id_val,
        element_class: element_class_val,
        element_index: element_index_val,
        parent_id: parent_id_val,
        parent_class: parent_class_val,
        parent_index: parent_index_val,
        grand_id: grand_id_val,
        grand_class: grand_class_val,
        grand_index: grand_index_val,
        great_grand_id: great_grand_id_val,
        great_grand_class: great_grand_class_val,
        element_placement: site_insert_element_placement,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // 差し込み配信施策削除
  // #################################################################
  $('#site_insert_delete_btn').on('click', function () {
    let site_insert_id = $('.site_insert_selects option:selected').val();

    if (!confirm('完全に削除され復元することはできません。本当に削除しますか？')) {
      return;
    }

    $.ajax({
      url: '/site_insert/delete_site_insert',
      type: 'POST',
      data: {
        site_insert_id: site_insert_id,
      },
      dataType: 'json',
    }).done(function (data) {
      alert('差し込み配信施策を削除しました。');
      location.href = `/site_insert/index`;
    });
  });
});
